// An existing user who is not logged in gets a 401 with a login_url from signup. Send them there
// instead of showing a generic payment error. Returns true when it navigated.
export const redirectToLogin = (json, assign = (url) => window.location.assign(url)) => {
  if (!json?.login_url) return false

  assign(json.login_url)
  return true
}
